import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  cardWrapper: {
    // border: '2px solid red',
    position: 'absolute',
    bottom: '68px',
    top: '150px',
    left: '41px',
    right: '41px',
    overflow: 'auto',
  },
}))

export { useStyles }
